'use client';

import { ParamItem } from '@/utils/SEOPathModule/convertPathToParams';
import {
  DictsGateState,
  OnChangeIsFreeType,
  OnChangePriceType,
  OnUpdateCategoriesType,
  OnUpdateParamType,
  PriceValue,
  ShownParams,
} from './types';
import { SimpleSearchInput } from '../SearchFilters/SimpleSearchInput';
import { MobileSearchForm } from '../SearchFilters/MobileSearchForm';
import { CategoriesSelect } from '../../main-page/CategoriesSelect';
import { useMediaQuerySafe } from '@/hooks/useMediaQuerySafe';
import { GeoSelector } from '../GeoSelector';
import { Spinner } from '@/components/ui/spinner';

type Props = {
  shownParameters: ShownParams;
  params: ParamItem[];
  price: PriceValue;
  categories: string[];
  searchValue: string;
  onSearchChange: (newVal: string) => void;
  onChangePrice: OnChangePriceType;
  isFree: boolean;
  onChangeIsFree: OnChangeIsFreeType;
  onUpdateParam: OnUpdateParamType;
  onUpdateCategory: OnUpdateCategoriesType;
  onClickSearch: () => void;
  onChangeSort: (newSort: string) => void;
  sort: string;
  onClear?: () => void;
  onSelectGeo?: (location: any) => void;
  dictsGateState?: DictsGateState;
  showFree?: boolean;
};

export const BaseSearch: React.FC<Props> = ({
  searchValue,
  onSearchChange,
  onClickSearch,
  params,
  shownParameters,
  price,
  isFree,
  categories,
  onChangePrice,
  onChangeIsFree,
  onUpdateCategory,
  onUpdateParam,
  onChangeSort,
  sort,
  onClear,
  onSelectGeo,
  dictsGateState = 'idle',
  showFree = false,
}) => {
  const isDesktop = useMediaQuerySafe('(min-width: 1024px)');
  const isBlocked = dictsGateState !== 'idle';

  return (
    <div className='relative w-full'>
      <SimpleSearchInput
        onClickSearch={onClickSearch}
        searchValue={searchValue}
        onChangeSearch={onSearchChange}
        filtersComponent={
          isDesktop ? undefined : (
            <MobileSearchForm
              showFree={showFree}
              params={params}
              shownParameters={shownParameters}
              price={price}
              isFree={isFree}
              categories={categories}
              onChangePrice={onChangePrice}
              onChangeIsFree={onChangeIsFree}
              onUpdateCategory={onUpdateCategory}
              onUpdateParam={onUpdateParam}
              onClear={onClear}
              sort={sort}
              onChangeSort={onChangeSort}
              onSubmit={onClickSearch}
              dictsGateState={dictsGateState}
            />
          )
        }
        leftPartComponent={isDesktop ? <CategoriesSelect /> : undefined}
        rightPartComponent={
          <div className='self-center lg:flex lg:justify-end hidden min-w-[281px] max-w-[281px]'>
            <GeoSelector onSelectGeo={onSelectGeo} />
          </div>
        }
      />

      {isBlocked && (
        <div className='absolute inset-0 z-10 rounded-[12px] bg-white/75 backdrop-blur-[1px] flex items-center justify-center'>
          {dictsGateState === 'loading' && (
            <div className='flex flex-col items-center gap-[8px] text-text-primary-day'>
              <Spinner className='size-[28px] text-primary-green-day' />
            </div>
          )}
          {dictsGateState === 'error' && (
            <div className='text-[14px] px-[16px] text-center text-text-primary-day'>Failed to load filters data.</div>
          )}
        </div>
      )}
    </div>
  );
};
